import { useTheme } from '@emotion/react'
import { Chip } from '@mui/material'
import { RosterType } from '__generated__/graphql'
import { FC } from 'react'

interface Props {
    rosterType?: RosterType
    rosterTypeLabel?: string
    title?: string
    sx?: React.CSSProperties
}

const RosterTypePill: FC<Props> = ({
    rosterType,
    rosterTypeLabel,
    title,
    sx,
}) => {
    const theme = useTheme()
    const backgroundColor = getRosterTypeColor(rosterType)
    return (
        <Chip
            title={title || 'Search Type'}
            size="small"
            label={rosterTypeLabel || rosterType || 'N/A'}
            sx={{
                backgroundColor,
                color: theme.palette.greyscale.white,
                ...sx,
            }}
        />
    )
}

export function getRosterTypeColor(rosterType?: RosterType) {
    switch (rosterType) {
        case RosterType.Search:
            return '#004583'
        case RosterType.Mapping:
            return '#5AA2EA'
        default:
            return '#B0BEC5'
    }
}

export default RosterTypePill
